export default "__VITE_ASSET__DF7Djodg__"